import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface Department {
    active: boolean;
    applyInCheckClock?: boolean;
    applyInPrompterReport?: boolean;
    applyInSupervisorReport?: boolean;
    applySecurityReport?: boolean;
    comments: string;
    createdAt: any;
    name: string;
    responsibleId: string;
    updatedAt: any;
}

interface DepartmentId extends Department {
    id: string;
}

@Injectable()
export class DepartmentService {

    departmentCollection: AngularFirestoreCollection<Department>;
    departments: any;

    departmentDocument: AngularFirestoreDocument<DepartmentId>;
    department: Observable<any>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.DEPARTMENT_COLLECTION;
    }

    postDepartment(departmentObject: any) {
        this.departmentCollection = this.afs.collection(this.collection);

        return this.departmentCollection.add(departmentObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getDepartments() {
        this.departmentCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', true).orderBy('name', 'asc'));

        this.departments = this.departmentCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Department;

                const name = data.name;
                const comments = data.comments;
                const responsibleId = data.responsibleId;
                const applyInPrompterReport = data.applyInPrompterReport;
                const applyInSupervisorReport = data.applyInSupervisorReport;
                const applyInCheckClock = data.applyInCheckClock;
                const applySecurityReport = data.applySecurityReport;

                return { id$, name, comments, responsibleId, applyInPrompterReport, applyInSupervisorReport, applyInCheckClock, applySecurityReport };
            });
        }).map(object => object);

        return this.departments;
    }

    getDepartment(id$: string) {
        this.departmentDocument = this.afs.doc(this.collection + '/' + id$);

        this.department = this.departmentDocument.valueChanges();

        return this.department.map(object => object);
    }

    putDepartment(departmentObject: any, id$: string) {
        this.departmentCollection = this.afs.collection(this.collection);

        return this.departmentCollection.doc(id$).update(departmentObject).then(function() {
            console.log('DEPARTMENT_SERVICE.putDepartment()', 'Document updated');
        }).catch(function(error) {
            console.error('DEPARTMENT_SERVICE.putDepartment()', 'Error updating document: ', error);
        });
    }

    /*
    // Method to delete the register from DB
    delDepartment(id$: string) {
        this.departmentDocument = this.afs.doc(this.collection + '/' + id$);

        return this.departmentDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delDepartment(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.departmentCollection = this.afs.collection(this.collection);

        return this.departmentCollection.doc(id$).update({ active: false, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

}
